import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldAlert, ArrowRight, Phone } from 'lucide-react';
import { siteConfig } from '../data';

export default function LatestNewsSection() {
  return (
    <section className="py-12 sm:py-16 bg-white" id="seneste-nyt">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-center">
          
          {/* Tekst til venstre - enkel, overskuelig og rolig */}
          <div className="lg:col-span-5 space-y-4">
            <span className="text-xs font-bold uppercase tracking-wider text-red-600 bg-red-100/80 px-2.5 py-1 inline-flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-red-600 animate-pulse" />
              Aktuel advarsel
            </span>
            
            <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight leading-snug">
              Pas på dine oplysninger ved det nye datalæk
            </h2>

            <p className="text-slate-600 text-sm sm:text-base leading-relaxed">
              Vi overvåger løbende trusler og svindel i Danmark. Har du mistanke om misbrug af dit MitID eller dine oplysninger, sidder vi klar ved telefonen til at hjælpe dig videre.
            </p>

            <div>
              <Link
                to="/vidensbank"
                className="inline-flex items-center text-sm font-semibold text-[#103B66] hover:underline"
              >
                <span>Find flere vejledninger i vidensbanken</span>
                <ArrowRight className="w-4 h-4 ml-1.5" />
              </Link>
            </div>
          </div>

          {/* Kasse til højre - enkel, ren boks med rød kant */}
          <div className="lg:col-span-7">
            <div className="bg-white border-2 border-red-600 shadow-lg p-6 sm:p-8">
              
              <div className="flex items-start gap-3.5 mb-4">
                <div className="p-2.5 bg-red-50 text-red-600 shrink-0 mt-0.5">
                  <ShieldAlert className="w-6 h-6" />
                </div>
                <div>
                  <span className="text-xs font-bold uppercase tracking-wider text-red-600 block mb-0.5">
                    Seneste nyt &bull; Datalæk i Danmark
                  </span>
                  <h3 className="text-xl sm:text-2xl font-bold text-slate-900 leading-snug">
                    Er dine personlige oplysninger i fare?
                  </h3>
                </div>
              </div>

              <p className="text-slate-600 text-sm leading-relaxed mb-5">
                Et omfattende datalæk har sat personnumre i omløb i Danmark, hvilket øger risikoen for phishing og falske bankopkald.
              </p>

              {/* Første tryghedssamtale opsummering */}
              <div className="bg-slate-50 border border-slate-200 p-4 sm:p-5 mb-5">
                <div className="flex items-baseline justify-between gap-2 mb-1.5">
                  <h4 className="font-bold text-slate-900 text-sm sm:text-base">
                    Første tryghedssamtale (ca. 10-15 min.)
                  </h4>
                  <span className="text-xl font-extrabold text-[#103B66]">
                    99,-
                  </span>
                </div>
                <p className="text-xs sm:text-sm text-slate-600 leading-relaxed mb-4">
                  Vi gennemgår din situation telefonisk, rådgiver dig konkret og opretter dig som kunde i vores system, så du altid er tryg, hvis du ringer igen.
                </p>

                <div className="flex flex-wrap sm:flex-nowrap gap-3">
                  <a
                    href={`tel:${siteConfig.phone.replace(/\s/g, '')}`}
                    className="flex-1 inline-flex items-center justify-center px-4 py-2.5 bg-[#103B66] hover:bg-[#0c2e50] text-white font-bold text-sm transition-colors text-center"
                  >
                    <Phone className="w-4 h-4 mr-2 shrink-0" />
                    <span>Ring ({siteConfig.phone})</span>
                  </a>
                  <Link
                    to="/vidensbank/massivt-datalaek-saadan-beskytter-du-dig"
                    className="flex-1 inline-flex items-center justify-center px-4 py-2.5 bg-red-600 hover:bg-red-700 text-white font-bold text-sm transition-colors text-center"
                  >
                    <span>Læs råd i artiklen</span>
                    <ArrowRight className="w-4 h-4 ml-1.5 shrink-0" />
                  </Link>
                </div>
              </div>

              <div className="text-right">
                <Link
                  to="/vidensbank"
                  className="text-xs font-medium text-slate-500 hover:text-[#103B66] transition-colors"
                >
                  Se alle artikler i vidensbanken &rarr;
                </Link>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
